import About from './about.presenter';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '../../..//shared/t-contents-params';
import ColumnLayout from '../column-layout';
import { useParams } from 'react-router-dom';

export default function AboutPage({}: IContentsContentElem<TContentsContentParams>) {
    const { lgcode } = useParams<{ lgcode: string }>();
    return (
        <ColumnLayout>
            <About lgcode={lgcode} />
        </ColumnLayout>
    );
}
